import { inject, Injectable, Provider } from "@angular/core";
import { map, Observable } from "rxjs";
import { IReminderListGetQuery, IReminderListGetQueryResult, ReminderDeleteCommandResult, ReminderDto, ReminderInitializeCommandResult, ReminderSetCommandResult } from "../../INTEGRA_Shop_Client";
import { IReminderService, IReminderServiceToken } from "./reminder-service.interface";
import { IReminderApiService, IReminderApiServiceToken } from "../../api/reminder/reminder-api-service.interface";

@Injectable({
  providedIn: 'root'
})
export class ReminderService implements IReminderService {

  private readonly reminderApiService: IReminderApiService;

  public constructor() {
    this.reminderApiService = inject(IReminderApiServiceToken);
  }

  public reminderListGet(
    params?: Partial<IReminderListGetQuery>,
    allowCancellation: boolean = false
  ): Observable<ReminderDto[] | undefined> {
    return this.reminderApiService.reminderListGet(params, allowCancellation).pipe(
      map(
        (result: IReminderListGetQueryResult) => {
          return result.reminderList;
        }
      )
    );
  }

  public reminderSet(reminder?: ReminderDto | undefined): Observable<ReminderSetCommandResult> {
    return this.reminderApiService.reminderSet(reminder);
  }

  public reminderInitialize(userNumber: string, customerNumber: string): Observable<ReminderInitializeCommandResult> {
    let reminder = new ReminderDto();
    reminder.userNumber = userNumber;
    reminder.customerNumber = customerNumber;

    return this.reminderApiService.reminderInitialize(reminder);
  }

  public reminderDelete(userNumber: string): Observable<ReminderDeleteCommandResult> {
    return this.reminderApiService.reminderDelete(userNumber);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ReminderServiceProvider: Provider =
  { provide: IReminderServiceToken, useExisting: ReminderService };
